// extracted by mini-css-extract-plugin
export default {"courses":"styles_courses__czn6u","__in":"styles___in__B1ysP","title":"styles_title__7Q+Ix","sub_title":"styles_sub_title__EQzm7","list":"styles_list__n7nTU"};